import { useMemo } from 'react';

import UserDevice from 'services/user-device';

export default function useIsMobile(): boolean {
    return !!useMemo(() => UserDevice.getInstance()?.isDeviceMobile(), []);
}
